// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textSm {
  font-size: 10px !important;
  height: 20px;
}

.surveyDisplay {
  display: flex;
  justify-content: "flex-start";
}

.surveyName {
  color: #001489;
  margin-left: 10px !important;
}

.jobberDisplay {
  display: flex;
  justify-content: "flex-end";
}

.jobberName {
  color: #001489;
  margin-right: 10px !important;
  margin-left: 10px !important;
}

.centerAlignment {
  align-items: center;
  margin-bottom: 15px;
}

.dateCreated {
  font-weight: bold;
  line-height: "20px";
}

.filterByPosition {
  position: relative;
}

.filterByMainDiv {
  border: 1px solid black;
  position: absolute;
  padding: 10px;
  width: 300px;
  background-color: white;
  top: 40;
  left: 0;
  z-index: 10;
}

.filterByDateCreated {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.filterByOr {
  align-items: center;
  align-self: center;
}

.filterByBtn {
  text-align: center;
  margin-top: 3px;
}

.surveyIcons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.surveyIconsStyle {
  height: 20px !important;
  stroke: #001489;
}

.surveyIconsStyle-bg {
  height: 40px !important;
  stroke: #001489;
}

.afterSurveyGrid {
  padding: 0;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 5px;
}
.selected-date-text {
  margin-left: 1.15em;
}
`, "",{"version":3,"sources":["webpack://./src/views/survey/Survey.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".textSm {\n  font-size: 10px !important;\n  height: 20px;\n}\n\n.surveyDisplay {\n  display: flex;\n  justify-content: \"flex-start\";\n}\n\n.surveyName {\n  color: #001489;\n  margin-left: 10px !important;\n}\n\n.jobberDisplay {\n  display: flex;\n  justify-content: \"flex-end\";\n}\n\n.jobberName {\n  color: #001489;\n  margin-right: 10px !important;\n  margin-left: 10px !important;\n}\n\n.centerAlignment {\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.dateCreated {\n  font-weight: bold;\n  line-height: \"20px\";\n}\n\n.filterByPosition {\n  position: relative;\n}\n\n.filterByMainDiv {\n  border: 1px solid black;\n  position: absolute;\n  padding: 10px;\n  width: 300px;\n  background-color: white;\n  top: 40;\n  left: 0;\n  z-index: 10;\n}\n\n.filterByDateCreated {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.filterByOr {\n  align-items: center;\n  align-self: center;\n}\n\n.filterByBtn {\n  text-align: center;\n  margin-top: 3px;\n}\n\n.surveyIcons {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.surveyIconsStyle {\n  height: 20px !important;\n  stroke: #001489;\n}\n\n.surveyIconsStyle-bg {\n  height: 40px !important;\n  stroke: #001489;\n}\n\n.afterSurveyGrid {\n  padding: 0;\n  margin: 0;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n.selected-date-text {\n  margin-left: 1.15em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
